import styled, { css } from "styled-components";
import { color, units } from "@m/alchemy-theme";
import { Checkbox } from "../form/checkbox/Checkbox";
import { Radio } from "../form/radio/Radio";
import { NakedButton } from "../naked-button/NakedButton";
import * as BinarySelectStyled from "../binary-select/BinarySelect.styled";
import { EDGE_PADDING } from "./MenuListItem.styled";
export const ForwardButtonWrapper = styled.span `
  display: flex;
  justify-content: flex-end;
  position: relative;
  flex-grow: 1;
`;
export const ForwardButtonIconWrapper = styled.span `
  border-radius: 4px;
  border: 1px solid transparent;
  margin-right: -10px;
  padding: 1px 6px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.1s ease-in;
`;
export const ForwardButton = styled(NakedButton).attrs({ noPadding: true }) `
  padding-right: ${EDGE_PADDING};
  height: 100%;

  outline: none;
  display: flex;
  justify-content: flex-end;

  flex-grow: 1;

  &:hover,
  [data-whatinput="keyboard"] &:focus {
    ${ForwardButtonIconWrapper} {
      transform: translateX(1px);
    }

    color: ${color("typeLink")};

    ${ForwardButtonIconWrapper} {
      background-color: ${color("hint", {
    palette: "interactiveConstructive"
})};
      border: 1px solid
        ${color("highlight", {
    palette: "interactiveConstructive"
})};
    }
  }
`;
export const ForwardIcon = styled.div `
  position: absolute;
  top: 50%;
  right: 10px;
  line-height: 0;
  transform: translateY(-50%);
  padding: 1px 6px;
`;
export const InteractiveMenuListItem = styled.span `
  align-content: center;
  border: 1px solid transparent;
  display: flex;
  font-weight: 400;
  justify-content: space-between;
  margin-right: 2px;
  outline: none;
  width: 100%;

  ${ForwardButton} {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }
`;
export const OptionCheckboxLabel = styled.span `
  display: inline-block;
  padding: ${units(1)} ${units(2)} ${units(1)} 0;
`;
const binarySelectLeftPaddingFix = (leftPadding) => css `
  padding-left: ${BinarySelectStyled.LEFT_PADDING + leftPadding}px;
  ${BinarySelectStyled.Control}, ${BinarySelectStyled.Input} {
    left: ${leftPadding}px;
  }
`;
export const OptionCheckbox = styled(Checkbox) `
  flex-grow: 1;
  ${({ isParent }) => isParent &&
    css `
      span {
        font-weight: bold;
      }
    `};

  ${({ isNarrow }) => binarySelectLeftPaddingFix(isNarrow ? units(2, true) : units(3, true))}
`;
export const OptionRadio = styled(Radio) `
  flex-grow: 1;
  ${({ isNarrow }) => binarySelectLeftPaddingFix(isNarrow ? units(2, true) : units(3, true))}
`;
